<template>
    <div class="row" v-if="canViewData">
        <clear-modal v-if="showModal" @close="showModal = false" :student="modalData"></clear-modal>
        <div class="col-sm-6 mb-5 flex">
            Reported infractions <br><br>
            <div v-if="canAssign && sortedInfractions.length > 0" class="d-flex justify-content-start mb-2">
            <span class="clickable text-danger small" @click="setModalData(infractions)">Clear All</span>
            </div>
            <div v-if="sortedInfractions.length === 0"><p class="text-muted">The infraction list is empty.</p></div>
            <ul class="list-group list-group-flush">
                <infraction v-for="(student, index) in sortedInfractions" 
                            :key="index" 
                            :student="student"
                            :index="index"
                            @modal="setModalData"
                />
            </ul>
        </div>

        <div class="col-sm-6">
            Detention list 
            <a href="#" class="dropdown-toggle ml-3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                sort
            </a>
            <div class="dropdown-menu">
                <button class="dropdown-item small" href="#" @click="sortByGrade=true">by grade</button>
                <button class="dropdown-item small" href="#" @click="sortByGrade=false">alphabetically (first name)</button>
            </div>
            <br><br>
        
            <div v-if="sortedDetentions.length > 0">
            <detention v-for="student in sortedDetentions"
                :key="student.id"
                :student="student"
                :detentionTypes="detentionTypes"
            />
            </div>
            <div v-else>
                <p class="text-muted">The detention list is empty.</p>
            </div>
        </div>
    </div>
</template>


<script>
import { db } from '@/main.js'
import Infraction from '@/components/Infraction.vue'
import Detention from '@/components/Detention.vue'
import ClearModal from '@/components/ClearModal.vue'

export default {
    name: 'DetentionList',
    components: {
        "infraction" : Infraction,
        "detention" : Detention,
        "clear-modal": ClearModal,
    },
    data () {
        return {
            infractions: [],
            detentions: [],
            sortByGrade: false,
            showModal: false,
            modalData: null,
            detentionTypes: ['Morning', 'Lunch', 'Other']
        }
    },
    computed: {
        sortedDetentions: function () {
            var filteredDetentions = this.detentions.filter(record => record.org === this.$root.sharedState.org)
            if (this.sortByGrade === true) {
                return filteredDetentions.slice().sort((a,b) => a.grade - b.grade)
            }
            return filteredDetentions.slice().sort(this.sortAlpha) 
        },
        sortedInfractions: function () {
            var filteredInfractions = this.infractions.filter(record => record.org === this.$root.sharedState.org)
            return filteredInfractions.slice().sort(this.sortAlpha)
        },
        canAssign: function() {
            return this.$root.sharedState.accessLevel >= 4
        },
        canViewData: function() {
        return this.$root.sharedState.accessLevel > 1
      }
    },
    methods: {
        sortAlpha: function (a,b) {
            var aUpper = a.name.toUpperCase();
            var bUpper = b.name.toUpperCase();
            if (aUpper > bUpper) {return 1}
            if (aUpper < bUpper) {return -1}
            return 0
        },
        setModalData: function (d) {
            this.modalData = d
            this.showModal = true
        },
    },
    firestore () {
        return {
            infractions: db.collection('students').where("infractionCounter", ">", 0),
            detentions: db.collection('students').where("detentionCounter", ">", 0)
        }
    },
}
</script>
